// Razorpay Standard Checkout helper.
// Loads the checkout script on demand, opens the modal, and returns a promise
// that resolves with { razorpay_order_id, razorpay_payment_id, razorpay_signature }
// on success or rejects with { code, description } on failure/cancel.

const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let _loadPromise = null;

function loadCheckoutScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_loadPromise) return _loadPromise;
  _loadPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = CHECKOUT_SRC;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => {
      _loadPromise = null;
      reject(new Error("Failed to load Razorpay checkout script"));
    };
    document.body.appendChild(s);
  });
  return _loadPromise;
}

export async function openRazorpayCheckout({
  keyId,
  order,        // { id, amount, currency }
  name = "GoPrintPack",
  description = "",
  prefill = {}, // { name, email, contact }
  themeColor = "#0d3d2c",
  notes = {},
}) {
  await loadCheckoutScript();
  if (!keyId) throw new Error("Missing Razorpay key_id");
  if (!order?.id) throw new Error("Missing Razorpay order id");

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: keyId,
      amount: order.amount,
      currency: order.currency || "INR",
      order_id: order.id,
      name,
      description,
      prefill,
      notes,
      theme: { color: themeColor },
      modal: {
        ondismiss: () => reject({ code: "USER_CANCELLED", description: "Payment cancelled" }),
      },
      handler: (resp) => {
        resolve({
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
      },
    });
    rzp.on("payment.failed", (resp) => {
      const err = resp?.error || {};
      reject({
        code: err.code || "PAYMENT_FAILED",
        description: err.description || "Payment failed",
        source: err.source,
        reason: err.reason,
      });
    });
    rzp.open();
  });
}
